import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        try {
          await processGoogleCallback(sessionId);
          // Redirect to dashboard or previous page
          const returnTo = sessionStorage.getItem('authReturnTo') || '/ferramentas';
          sessionStorage.removeItem('authReturnTo');
          navigate(returnTo, { replace: true });
        } catch (error) {
          console.error('Google auth error:', error);
          navigate('/login?error=auth_failed', { replace: true });
        }
      } else {
        // No session_id, redirect to login
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [location, navigate, processGoogleCallback]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F7]">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-[#C4B5A0] mx-auto mb-4" />
        <p className="text-[#6B4E37]">A processar autenticação...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
